let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ZBbVa")).then(() => parcelRequire('jVVB7'));